import React from 'react';

import { OrderDetail } from 'components/blocks/Order';

const DetailScreen = (props) => {
  return (
    <div className="page-main">
      <OrderDetail />
    </div>
  );
};

export default DetailScreen;
